import { Capacitor, registerPlugin } from '@capacitor/core';

// Questo plugin esiste solo nell'APK Android. Nel browser l'app continua a
// comportarsi normalmente e le modifiche della Web App restano immediate.
const AppUpdate = registerPlugin('AppUpdate');
const URL_MANIFEST_AGGIORNAMENTI = 'https://academy-of-arts-allievi.web.app/aggiornamenti/android/versione.json';

function versioneValida(valore) {
  const numero = Number(valore);
  return Number.isInteger(numero) && numero > 0 ? numero : null;
}

function aggiornamentoValido(dati) {
  const versionCode = versioneValida(dati?.versionCode);
  const apkUrl = String(dati?.apkUrl || '').trim();
  const sha256 = String(dati?.sha256 || '').trim().toLowerCase();
  return Boolean(versionCode && apkUrl.startsWith('https://') && /^[a-f0-9]{64}$/.test(sha256));
}

export async function controllaAggiornamentoAndroid() {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') {
    return { stato: 'non_android' };
  }

  try {
    const [installata, risposta] = await Promise.all([
      AppUpdate.getInstalledVersion(),
      fetch(`${URL_MANIFEST_AGGIORNAMENTI}?t=${Date.now()}`, { cache: 'no-store' })
    ]);
    if (!risposta.ok) return { stato: 'non_disponibile' };

    const disponibile = await risposta.json();
    const versioneInstallata = versioneValida(installata?.versionCode);
    if (!versioneInstallata || !aggiornamentoValido(disponibile) || disponibile.versionCode <= versioneInstallata) {
      return { stato: 'aggiornata' };
    }

    return {
      stato: 'disponibile',
      versionCode: disponibile.versionCode,
      versionName: String(disponibile.versionName || `versione ${disponibile.versionCode}`),
      apkUrl: disponibile.apkUrl,
      sha256: disponibile.sha256,
      obbligatorio: disponibile.obbligatorio === true,
      note: String(disponibile.note || '').trim()
    };
  } catch (errore) {
    console.warn('Controllo aggiornamento Android non riuscito:', errore);
    return { stato: 'errore' };
  }
}

// Serve solo per mostrare con chiarezza all'allievo la versione dell'APK
// effettivamente installato sul suo telefono.
export async function leggiVersioneAndroidInstallata() {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') return null;
  try {
    return await AppUpdate.getInstalledVersion();
  } catch (errore) {
    console.warn('Impossibile leggere la versione Android installata:', errore);
    return null;
  }
}

export async function scaricaAggiornamentoAndroid(aggiornamento) {
  if (!aggiornamento?.apkUrl || !aggiornamento?.sha256) {
    throw new Error('Aggiornamento non valido.');
  }
  return AppUpdate.downloadAndInstall({
    url: aggiornamento.apkUrl,
    sha256: aggiornamento.sha256
  });
}
